"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Components = void 0;
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _Typography = _interopRequireDefault(require("../../Typography"));
var _Icon = _interopRequireDefault(require("../../Icon"));
var _Box = _interopRequireDefault(require("../../Box"));
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
const MenuWrapper = (0, _styledComponents["default"])(_Box["default"])(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n  flex-direction: column;\n  margin-top: ", ";\n  overflow-x: ", ";\n"])), _ref => {
  let {
    theme
  } = _ref;
  return theme.space['32'];
}, _ref2 => {
  let {
    isExpanded
  } = _ref2;
  return isExpanded ? 'auto' : 'unset';
});
const menuListStyles = (0, _styledComponents.css)(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  height: 100%;\n"])));
const MenuList = _styledComponents["default"].ul(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2["default"])(["\n  ", ";\n  width: 100%;\n  margin-top: ", ";\n"])), menuListStyles, _ref3 => {
  let {
    theme
  } = _ref3;
  return theme.space[8];
});
const CollapsedMenu = _styledComponents["default"].ul(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2["default"])(["\n  ", ";\n  height: auto;\n  margin: 0;\n  padding: 0;\n  padding-top: ", ";\n  position: absolute;\n  left: ", ";\n  top: ", ";\n  width: 195px;\n  background-color: ", ";\n  box-shadow: ", ";\n  border: 1px solid ", ";\n  z-index: ", ";\n"])), menuListStyles, _ref4 => {
  let {
    theme
  } = _ref4;
  return theme.space[8];
}, _ref5 => {
  let {
    isSubChildMenu,
    minWidth
  } = _ref5;
  return isSubChildMenu ? minWidth ? "".concat(minWidth + 122, "px") : '188px' : minWidth ? "".concat(minWidth - 6, "px") : '60px';
}, _ref6 => {
  let {
    theme
  } = _ref6;
  return theme.space['20'];
}, _ref7 => {
  let {
    theme,
    themeMode
  } = _ref7;
  return themeMode === 'dark' ? theme.colors.primary.blue['900'] : theme.colors.functional.grey['50'];
}, _ref8 => {
  let {
    theme
  } = _ref8;
  return theme.boxShadows.card['4'];
}, _ref9 => {
  let {
    theme
  } = _ref9;
  return theme.colors.functional.grey['200'];
}, _ref10 => {
  let {
    theme
  } = _ref10;
  return theme.zindexes['1'];
});
const CustomImageIcon = _styledComponents["default"].img(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2["default"])(["\n  width: ", ";\n  height: ", ";\n"])), _ref11 => {
  let {
    theme
  } = _ref11;
  return theme.space['20'];
}, _ref12 => {
  let {
    theme
  } = _ref12;
  return theme.space['20'];
});
const MenuListItem = _styledComponents["default"].li(_templateObject6 || (_templateObject6 = (0, _taggedTemplateLiteral2["default"])(["\n  list-style-type: none;\n  cursor: pointer;\n  position: relative;\n"])));
const menuItemActive = (0, _styledComponents.css)(_templateObject7 || (_templateObject7 = (0, _taggedTemplateLiteral2["default"])(["\n  background-color: ", "50;\n  &:hover {\n    color: ", ";\n    svg,\n    img {\n      filter: ", ";\n    }\n  }\n  &:after {\n    background-color: ", ";\n    content: '';\n    width: ", ";\n    height: 100%;\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n  }\n"])), _ref13 => {
  let {
    theme
  } = _ref13;
  return theme.colors.primary.blue['50'];
}, _ref14 => {
  let {
    theme,
    themeMode
  } = _ref14;
  return themeMode === 'dark' ? '' : theme.colors.primary.blue['600'];
}, _ref15 => {
  let {
    themeMode
  } = _ref15;
  return themeMode === 'dark' ? '' : "invert(12%) sepia(80%) saturate(3770%) hue-rotate(190deg)\n          brightness(97%) contrast(60%)";
}, _ref16 => {
  let {
    theme
  } = _ref16;
  return theme.colors.primary.blue['600'];
}, _ref17 => {
  let {
    theme
  } = _ref17;
  return theme.space['4'];
});
const menuItemDefault = (0, _styledComponents.css)(_templateObject8 || (_templateObject8 = (0, _taggedTemplateLiteral2["default"])(["\n  &:hover {\n    background-color: ", ";\n    & i,\n    span {\n      color: ", ";\n    }\n    & svg,\n    img {\n      filter: ", ";\n    }\n  }\n"])), _ref18 => {
  let {
    themeMode
  } = _ref18;
  return themeMode === 'dark' ? 'rgba(255, 255, 255, 0.15)' : '';
}, _ref19 => {
  let {
    theme,
    themeMode
  } = _ref19;
  return themeMode === 'dark' ? '' : theme.colors.primary.blue['600'];
}, _ref20 => {
  let {
    themeMode
  } = _ref20;
  return themeMode === 'dark' ? '' : "invert(12%) sepia(80%) saturate(3770%) hue-rotate(190deg)\n          brightness(97%) contrast(60%)";
});
const MenuItemContent = _styledComponents["default"].a(_templateObject9 || (_templateObject9 = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: ", ";\n  color: ", ";\n  ", ";\n"])), _ref21 => {
  let {
    theme,
    isExpanded
  } = _ref21;
  return isExpanded ? "".concat(theme.space['4'], " ").concat(theme.space['8'], " ").concat(theme.space['4'], " ").concat(theme.space['20']) : "".concat(theme.space['12'], " ").concat(theme.space['4']);
}, _ref22 => {
  let {
    theme,
    themeMode
  } = _ref22;
  return themeMode === 'dark' ? theme.colors.functional.grey['50'] : theme.colors.functional.grey['800'];
}, _ref23 => {
  let {
    isActiveNav
  } = _ref23;
  return isActiveNav ? menuItemActive : menuItemDefault;
});
const ContentWrapper = _styledComponents["default"].div(_templateObject10 || (_templateObject10 = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n  align-items: center;\n  width: 100%;\n  & i {\n    color: ", ";\n    width: ", ";\n    height: ", ";\n    margin-right: ", ";\n  }\n  & img,\n  svg {\n    filter: ", ";\n    width: ", ";\n    height: ", ";\n    margin-right: ", ";\n  }\n  ", ";\n"])), _ref24 => {
  let {
    theme,
    themeMode
  } = _ref24;
  return themeMode === 'dark' ? 'aliceblue' : theme.colors.functional.grey['800'];
}, _ref25 => {
  let {
    theme
  } = _ref25;
  return theme.space['24'];
}, _ref26 => {
  let {
    theme
  } = _ref26;
  return theme.space['24'];
}, _ref27 => {
  let {
    theme,
    isExpanded
  } = _ref27;
  return isExpanded ? theme.space['12'] : 'unset';
}, _ref28 => {
  let {
    themeMode
  } = _ref28;
  return themeMode === 'dark' ? 'invert(100%) saturate(0) brightness(200%)' : '';
}, _ref29 => {
  let {
    theme
  } = _ref29;
  return theme.space['24'];
}, _ref30 => {
  let {
    theme
  } = _ref30;
  return theme.space['24'];
}, _ref31 => {
  let {
    theme,
    isExpanded
  } = _ref31;
  return isExpanded ? theme.space['12'] : 'unset';
}, _ref32 => {
  let {
    isExpanded
  } = _ref32;
  return !isExpanded && MenuItemCollapsed;
});
const ItemTitle = (0, _styledComponents["default"])(_Typography["default"])(_templateObject11 || (_templateObject11 = (0, _taggedTemplateLiteral2["default"])(["\n  color: ", ";\n  margin: ", ";\n"])), _ref33 => {
  let {
    theme,
    themeMode
  } = _ref33;
  return themeMode === 'dark' ? theme.colors.functional.grey['50'] : theme.colors.functional.grey['800'];
}, _ref34 => {
  let {
    theme,
    isExpanded
  } = _ref34;
  return isExpanded ? "".concat(theme.space['12'], " ").concat(theme.space['12'], " ").concat(theme.space['12']) : "".concat(theme.space['12'], " auto}");
});
const DropdownIcon = (0, _styledComponents["default"])(_Icon["default"])(_templateObject12 || (_templateObject12 = (0, _taggedTemplateLiteral2["default"])(["\n  color: ", ";\n"])), _ref35 => {
  let {
    theme,
    themeMode
  } = _ref35;
  return themeMode === 'dark' ? 'aliceblue' : theme.colors.functional.grey['800'];
});
const MenuItemCollapsed = (0, _styledComponents.css)(_templateObject13 || (_templateObject13 = (0, _taggedTemplateLiteral2["default"])(["\n  display: block;\n  text-align: center;\n  & span {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    display: block;\n  }\n"])));
const SubMenuListItem = _styledComponents["default"].li(_templateObject14 || (_templateObject14 = (0, _taggedTemplateLiteral2["default"])(["\n  list-style: none;\n  cursor: pointer;\n  position: relative;\n  margin-bottom: ", ";\n"])), _ref36 => {
  let {
    theme
  } = _ref36;
  return theme.space['8'];
});
const SubMenuContent = _styledComponents["default"].a(_templateObject15 || (_templateObject15 = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n  justify-content: space-between;\n  cursor: pointer;\n  padding: ", ";\n  color: ", ";\n  ", ";\n"])), _ref37 => {
  let {
    theme,
    isExpanded,
    isSubChildMenu
  } = _ref37;
  return isExpanded ? isSubChildMenu ? "".concat(theme.space['10'], " ").concat(theme.space['8'], " ").concat(theme.space['10'], " ").concat(theme.space['64']) : "".concat(theme.space['10'], " ").concat(theme.space['8'], " ").concat(theme.space['10'], " ").concat(theme.space['48']) : "".concat(theme.space['12']);
}, _ref38 => {
  let {
    theme,
    themeMode
  } = _ref38;
  return themeMode === 'dark' ? theme.colors.functional.grey['50'] : theme.colors.functional.grey['800'];
}, _ref39 => {
  let {
    isActiveNav
  } = _ref39;
  return isActiveNav ? menuItemActive : menuItemDefault;
});
const Components = exports.Components = {
  MenuWrapper,
  MenuList,
  CollapsedMenu,
  MenuItemContent,
  MenuListItem,
  SubMenuListItem,
  ContentWrapper,
  ItemTitle,
  SubMenuContent,
  CustomImageIcon,
  DropdownIcon
};